var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { css, keyframes } from 'styled-components';
var FadeInAnimationKeyframes = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n"])));
export var FadeInAnimation = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  opacity: 0;\n  animation-name: ", ";\n  animation-timing-function: ease-in-out;\n  animation-fill-mode: forwards;\n  animation-duration: 0.6s;\n"], ["\n  opacity: 0;\n  animation-name: ", ";\n  animation-timing-function: ease-in-out;\n  animation-fill-mode: forwards;\n  animation-duration: 0.6s;\n"])), FadeInAnimationKeyframes);
var templateObject_1, templateObject_2;